var map = {
	"./music-instructions.json": 4535,
	"./music-library-intro2024.json": 4536,
	"./music-library-launch2024.json": 4537,
	"./music-progression.json": 4538,
	"./startSourcesAdvanced.json": 4539,
	"./startSourcesSimple.json": 4540,
	"./startSourcesSimple2.json": 4541,
	"./startSourcesTracks.json": 4542
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4314;